// @flow

import React from 'react'

function isVimeoUrl(url) {
  return url && url.match(/vimeo\.com/)
}

function videoId(url) {
  const arr = url.split(isVimeoUrl(url) ? '/' : '=')
  return arr[arr.length - 1]
}

function videoUrl(url) {
  if (isVimeoUrl(url)) {
    return `//player.vimeo.com/video/${videoId(url)}`
  }
  return `//www.youtube.com/embed/${videoId(url)}`
}

export default ({ url }: { url: string }) =>
  url ? (
    <div className="space-main__video">
      <iframe src={videoUrl(url)} frameBorder="0" allowFullScreen />
    </div>
  ) : null



// WEBPACK FOOTER //
// ./src/components/molecules/room/DetailVideo/index.jsx